import first from "../src/assets/images/teams/person-1.png";
import second from "../src/assets/images/teams/person-2.png";
import third from "../src/assets/images/teams/person-3.png";
import fifth from "../src/assets/images/teams/person-5.png";
import sixth from "../src/assets/images/teams/person-6.png";
import seventh from "../src/assets/images/teams/person-7.png";
import ninth from "../src/assets/images/teams/person-9.png";
import twelfth from "../src/assets/images/teams/person-12.png";
import fourteenth from "../src/assets/images/teams/person-14.png";
import fifteenth from "../src/assets/images/teams/person-15.png";
import sixteenth from "../src/assets/images/teams/person-16.png";
import seventeenth from "../src/assets/images/teams/person-17.png";
// CASES CHINA

import cargoResultFirstMobile from "../src/assets/images/cases/china/cargoResultFirstMobile.png";
import cargoResultSecondMobile from "../src/assets/images/cases/china/cargoResultSecondMobile.png";
import cargoResultThirdMobile from "../src/assets/images/cases/china/cargoResultThirdMobile.png";
import cargoResultFirstTablet from "../src/assets/images/cases/china/cargoResultFirstTablet.png";
import cargoResultSecondTablet from "../src/assets/images/cases/china/cargoResultSecondTablet.png";
import cargoResultThirdTablet from "../src/assets/images/cases/china/cargoResultThirdTablet.png";
import cargoResultFirstDesktop from "../src/assets/images/cases/china/cargoResultFirstDesktop.png";
import cargoResultSecondDesktop from "../src/assets/images/cases/china/cargoResultSecondDesktop.png";
import cargoResultThirdDesktop from "../src/assets/images/cases/china/cargoResultThirdDesktop.png";

// CASES INDIA

import indiaResultFirstMobile from "../src/assets/images/cases/india/indiaResultFirstMobile.png";
import indiaResultSecondMobile from "../src/assets/images/cases/india/indiaResultSecondMobile.png";
import indiaResultFirstTablet from "../src/assets/images/cases/india/indiaResultFirstTablet.png";
import indiaResultSecondTablet from "../src/assets/images/cases/india/indiaResultSecondTablet.png";
import indiaResultFirstDesktop from "../src/assets/images/cases/india/indiaResultFirstDesktop.png";
import indiaResultSecondDesktop from "../src/assets/images/cases/india/indiaResultSecondDesktop.png";

// CASES CHINA SECOND

import chinaSecondFirstMobile from "../src/assets/images/cases/chinaSecond/chinaSecondFirstMobile.png";
import chinaSecondSecondMobile from "../src/assets/images/cases/chinaSecond/chinaSecondSecondMobile.png";
import chinaSecondThirdMobile from "../src/assets/images/cases/chinaSecond/chinaSecondThirdMobile.png";
import chinaSecondFirstTablet from "../src/assets/images/cases/chinaSecond/chinaSecondFirstTablet.png";
import chinaSecondSecondTablet from "../src/assets/images/cases/chinaSecond/chinaSecondSecondTablet.png";
import chinaSecondThirdTablet from "../src/assets/images/cases/chinaSecond/chinaSecondThirdTablet.png";
import chinaSecondFirstDesktop from "../src/assets/images/cases/chinaSecond/chinaSecondFirstDesktop.png";
import chinaSecondSecondDesktop from "../src/assets/images/cases/chinaSecond/chinaSecondSecondDesktop.png";
import chinaSecondThirdDesktop from "../src/assets/images/cases/chinaSecond/chinaSecondThirdDesktop.png";

// CASES CHINA THIRD

import chinaThirdFirstMobile from "../src/assets/images/cases/chinaThird/chinaThirdFirstMobile.png";
import chinaThirdSecondMobile from "../src/assets/images/cases/chinaThird/chinaThirdSecondMobile.png";
import chinaThirdThirdMobile from "../src/assets/images/cases/chinaThird/chinaThirdThirdMobile.png";
import chinaThirdFirstTablet from "../src/assets/images/cases/chinaThird/chinaThirdFirstTablet.png";
import chinaThirdSecondTablet from "../src/assets/images/cases/chinaThird/chinaThirdSecondTablet.png";
import chinaThirdThirdTablet from "../src/assets/images/cases/chinaThird/chinaThirdThirdTablet.png";
import chinaThirdFirstDesktop from "../src/assets/images/cases/chinaThird/chinaThirdFirstDesktop.png";
import chinaThirdSecondDesktop from "../src/assets/images/cases/chinaThird/chinaThirdSecondDesktop.png";
import chinaThirdThirdDesktop from "../src/assets/images/cases/chinaThird/chinaThirdThirdDesktop.png";

// CARGO TANKS

import containerSmall from "../src/assets/images/park/container-20.png";
import containerBig from "../src/assets/images/park/container-40.png";
import machineBlueMobile from "../src/assets/images/cases/machineBlueMobile.png";
import machineGrayMobile from "../src/assets/images/cases/machineGrayMobile.png";
import machineBlueTablet from "../src/assets/images/cases/machineBlueTablet.png";
import machineGrayTablet from "../src/assets/images/cases/machineGrayTablet.png";
import machineBlueDesktop from "../src/assets/images/cases/machineBlueDesktop.png";
import machineGrayDesktop from "../src/assets/images/cases/machineGrayDesktop.png";

import craneBlueMobile from "../src/assets/images/cases/craneBlueMobile.png";
import craneGrayMobile from "../src/assets/images/cases/craneGrayMobile.png";
import craneBlueTablet from "../src/assets/images/cases/craneBlueTablet.png";
import craneGrayTablet from "../src/assets/images/cases/craneGrayTablet.png";
import craneBlueDesktop from "../src/assets/images/cases/craneBlueDesktop.png";
import craneGrayDesktop from "../src/assets/images/cases/craneGrayDesktop.png";

import containerBlueMobile from "../src/assets/images/cases/containerBlueMobile.png";
import containerGrayMobile from "../src/assets/images/cases/containerGrayMobile.png";
import containerBlueTablet from "../src/assets/images/cases/containerBlueTablet.png";
import containerGrayTablet from "../src/assets/images/cases/containerGrayTablet.png";
import containerBlueDesktop from "../src/assets/images/cases/containerBlueDesktop.png";
import containerGrayDesktop from "../src/assets/images/cases/containerGrayDesktop.png";

import shipBlueMobile from "../src/assets/images/cases/shipBlueMobile.png";
import shipGrayMobile from "../src/assets/images/cases/shipGrayMobile.png";
import shipBlueTablet from "../src/assets/images/cases/shipBlueTablet.png";
import shipGrayTablet from "../src/assets/images/cases/shipGrayTablet.png";
import shipBlueDesktop from "../src/assets/images/cases/shipBlueDesktop.png";
import shipGrayDesktop from "../src/assets/images/cases/shipGrayDesktop.png";

// SOLUTION

import cargoSolutionBigMobile from "../src/assets/images/solution/cargoSolutionBigMobile.png";
import cargoSolutionSmallLeftMobile from "../src/assets/images/solution/cargoSolutionSmallLeftMobile.png";
import cargoSolutionSmallRightMobile from "../src/assets/images/solution/cargoSolutionSmallRightMobile.png";
import cargoSolutionBigTablet from "../src/assets/images/solution/cargoSolutionBigTablet.png";
import cargoSolutionSmallLeftTablet from "../src/assets/images/solution/cargoSolutionSmallLeftTablet.png";
import cargoSolutionSmallRightTablet from "../src/assets/images/solution/cargoSolutionSmallRightTablet.png";
import cargoSolutionBigDesktop from "../src/assets/images/solution/cargoSolutionBigDesktop.png";
import cargoSolutionSmallLeftDesktop from "../src/assets/images/solution/cargoSolutionSmallLeftDesktop.png";
import cargoSolutionSmallRightDesktop from "../src/assets/images/solution/cargoSolutionSmallRightDesktop.png";
// SERVICES

import imgSeaBluePreviewMobile from "../src/assets/images/service/sea/imgSeaBluePreviewMobile.png";
import imgSeaBluePreviewTablet from "../src/assets/images/service/sea/imgSeaBluePreviewTablet.png";
import imgSeaBluePreviewDesktop from "../src/assets/images/service/sea/imgSeaBluePreviewDesktop.png";
import seaServiceBlue from "../src/assets/images/service/sea/seaServiceBluePreview.png";
import seaServiceGray from "../src/assets/images/service/sea/seaServiceGrayPreview.png";
import seaServiceBlueMobile from "../src/assets/images/service/sea/seaServiceBlueMobile.png";
import seaServiceGrayMobile from "../src/assets/images/service/sea/seaServiceGrayMobile.png";
import seaServiceBlueTablet from "../src/assets/images/service/sea/seaServiceBlueTablet.png";
import seaServiceGrayTablet from "../src/assets/images/service/sea/seaServiceGrayTablet.png";
import seaServiceBlueDesktop from "../src/assets/images/service/sea/seaServiceBlueDesktop.png";
import seaServiceGrayDesktop from "../src/assets/images/service/sea/seaServiceGrayDesktop.png";

import imgTrainBluePreviewMobile from "../src/assets/images/service/train/imgTrainBluePreviewMobile.png";
import imgTrainBluePreviewTablet from "../src/assets/images/service/train/imgTrainBluePreviewTablet.png";
import imgTrainBluePreviewDesktop from "../src/assets/images/service/train/imgTrainBluePreviewDesktop.png";
import trainServiceBlue from "../src/assets/images/service/train/trainServiceBluePreview.png";
import trainServiceGray from "../src/assets/images/service/train/trainServiceGrayPreview.png";
import trainServiceBlueMobile from "../src/assets/images/service/train/trainServiceBlueMobile.png";
import trainServiceGrayMobile from "../src/assets/images/service/train/trainServiceGrayMobile.png";
import trainServiceBlueTablet from "../src/assets/images/service/train/trainServiceBlueTablet.png";
import trainServiceGrayTablet from "../src/assets/images/service/train/trainServiceGrayTablet.png";
import trainServiceBlueDesktop from "../src/assets/images/service/train/trainServiceBlueDesktop.png";
import trainServiceGrayDesktop from "../src/assets/images/service/train/trainServiceGrayDesktop.png";

import imgCarBluePreviewMobile from "../src/assets/images/service/car/imgCarBluePreviewMobile.png";
import imgCarBluePreviewTablet from "../src/assets/images/service/car/imgCarBluePreviewTablet.png";
import imgCarBluePreviewDesktop from "../src/assets/images/service/car/imgCarBluePreviewDesktop.png";
import carServiceBlue from "../src/assets/images/service/car/carServiceBluePreview.png";
import carServiceGray from "../src/assets/images/service/car/carServiceGrayPreview.png";
import carServiceBlueMobile from "../src/assets/images/service/car/carServiceBlueMobile.png";
import carServiceGrayMobile from "../src/assets/images/service/car/carServiceGrayMobile.png";
import carServiceBlueTablet from "../src/assets/images/service/car/carServiceBlueTablet.png";
import carServiceGrayTablet from "../src/assets/images/service/car/carServiceGrayTablet.png";
import carServiceBlueDesktop from "../src/assets/images/service/car/carServiceBlueDesktop.png";
import carServiceGrayDesktop from "../src/assets/images/service/car/carServiceGrayDesktop.png";

import aviaServiceBlue from "../src/assets/images/service/avia/aviaServiceBluePreview.png";
import aviaServiceGray from "../src/assets/images/service/avia/aviaServiceGrayPreview.png";
import aviaServiceBlueMobile from "../src/assets/images/service/avia/aviaServiceBlueMobile.png";
import aviaServiceGrayMobile from "../src/assets/images/service/avia/aviaServiceGrayMobile.png";
import aviaServiceBlueTablet from "../src/assets/images/service/avia/aviaServiceBlueTablet.png";
import aviaServiceGrayTablet from "../src/assets/images/service/avia/aviaServiceGrayTablet.png";
import aviaServiceBlueDesktop from "../src/assets/images/service/avia/aviaServiceBlueDesktop.png";
import aviaServiceGrayDesktop from "../src/assets/images/service/avia/aviaServiceGrayDesktop.png";

import multiServiceBlue from "../src/assets/images/service/multi/multiServiceBluePreview.png";
import multiServiceBluePreviewMobile from "../src/assets/images/service/multi/multiServiceBluePreviewMobile.png";
import multiServiceBluePreviewTablet from "../src/assets/images/service/multi/multiServiceBluePreviewTablet.png";
import multiServiceGray from "../src/assets/images/service/multi/multiServiceGrayPreview.png";
import multiServiceBlueMobile from "../src/assets/images/service/multi/multiServiceBlueMobile.png";
import multiServiceGrayMobile from "../src/assets/images/service/multi/multiServiceGrayMobile.png";
import multiServiceBlueTablet from "../src/assets/images/service/multi/multiServiceBlueTablet.png";
import multiServiceGrayTablet from "../src/assets/images/service/multi/multiServiceGrayTablet.png";
import multiServiceBlueDesktop from "../src/assets/images/service/multi/multiServiceBlueDesktop.png";
import multiServiceGrayDesktop from "../src/assets/images/service/multi/multiServiceGrayDesktop.png";

export const Teams = [
  {
    id: 0,
    avatar: first,
    name: "Юлия Бакаева",
    business: "Генеральный директор",
  },
  {
    id: 1,
    avatar: second,
    name: "Эдгар Мартиросян",
    business: "Коммерческий директор",
  },
  {
    id: 2,
    avatar: third,
    name: "Елена Лямова",
    business: "Главный бухгалтер",
  },
  {
    id: 4,
    avatar: fifth,
    name: "Юлия Субботкина",
    business: "Руководитель отдела экспортных перевозок",
  },
  {
    id: 5,
    avatar: sixth,
    name: "Дмитрий Медведков",
    business: "Руководитель отдела импортных перевозок",
  },
  {
    id: 6,
    avatar: seventh,
    name: "Михаил Епанчинцев",
    business: "Руководитель отдела перевозок по России",
  },
  {
    id: 11,
    avatar: twelfth,
    name: "Жанна Паради",
    business: "Руководитель отдела персонала",
  },
  {
    id: 13,
    avatar: fourteenth,
    name: "Денис Лебедев",
    business: "Руководитель отдела продаж",
  },
  {
    id: 14,
    avatar: fifteenth,
    name: "Дмитрий Нечипурук",
    business: "Руководитель отдела логистики",
  },
  {
    id: 15,
    avatar: sixteenth,
    name: "Виталий Казакулов",
    business: "Руководитель офиса г. Новосибирск",
  },
  {
    id: 16,
    avatar: seventeenth,
    name: "Николай Бакаев",
    business: "Руководитель офиса г. Москва",
  },
];

export const casesPage = [
  {
    id: 0,
    path: "1",
    case: "china",
    imgBlueMobile: machineBlueMobile,
    imgGrayMobile: machineGrayMobile,
    imgBlueTablet: machineBlueTablet,
    imgGrayTablet: machineGrayTablet,
    imgGrayDesktop: machineGrayDesktop,
    imgBlueDesktop: machineBlueDesktop,
    bigBlueImg: machineBlueDesktop,
    heading: "Станок из Китая весом 172 тонны",
    caseHeading: "Станок из Китая весом 172 тонны",
    alt: "machine",
    options: {
      title: "Параметры доставки",
      conditions: [
        {
          id: 0,
          heading: "Что",
          text: "Сварочное оборудование для автоматической электродуговой сварки металлов",
        },
        {
          id: 1,
          heading: "Сколько",
          text: "172 тонны",
        },
        { id: 2, heading: "Откуда ", text: "Порт Ксинганг, Китай" },
        { id: 3, heading: "Куда", text: "Волгодонск, Ростовская область" },
      ],
    },
    process: {
      title: "Процесс",
      descr: [
        {
          id: 0,
          text: "Нам предстояло рассчитать оптимальное кол-во контейнеров для перевозки мелких деталей станка и предложить вариант транспортировки негабаритных деталей. Особое условие – груз должен прибыть в порт назначения на один терминал (для таможенной очистки) и примерно в одно и то же время (для избежания лишних расходов по хранению).",
        },
        {
          id: 1,
          text: "Мелкие детали было решено отправить в 10*40 футовых контейнерах на линии FESCO в порт ВМТП. Почему именно этот порт? – Здесь есть возможности по разгрузке тяжелых и негабаритных грузов. Это тоже нужно было учитывать при выборе порта назначения.",
        },
        {
          id: 2,
          text: "По негабаритным местам – сначала хотели использовать контейнеры типа Flat Rack (FR), но это оказалось очень дорого. Предложили клиенту отправить их балкерным судном (когда груз просто ставится на корабль), что оказалось в разы дешевле и не менее надежно. Осталось только подобрать суда примерно с одной датой выхода и подстроится под готовность груза клиента.",
        },
      ],
    },
    solution: {
      title: "Решение",
      descr: [
        {
          id: 0,
          heading:
            "Предложили альтернативное решение по перевозке негабаритного груза",
          text: "Отправили крупные детали балкерным судном (навалом). Благодаря этому оптимизировали стоимость доставки, так как это в разы дешевле и не менее надежно, чем стандартная перевозка такого груза контейнерами FlatRack.",
        },
        {
          id: 1,
          heading: "Подобрали оборудование для мелких деталей.",
          text: "Перевезли их в 10×40 фт. контейнерах на линии FESCO.",
        },
        {
          id: 2,
          heading: "Выбрали порт разгрузки с учетом особенностей груза",
          text: "Отправили станок в торговый порт Владивосток: там есть возможность выгрузки тяжелых и негабаритных грузов.",
        },
        {
          id: 3,
          heading:
            "Минимизировали время доставки за счет правильной стыковки на всех этапах перевозки",
          text: "Ориентируясь на время готовности груза со стороны клиента, подобрали суда с минимальным разрывом отправки в 5 дней.",
        },
        {
          id: 4,
          heading: "Спланировали пересадки для доставки мелких деталей",
          text: "Все контейнеры были отправлены по ж/д до станции Ростов – Товарный, а затем доставлены на авто до склада клиента в Волгодонск.",
        },
        {
          id: 5,
          heading: "Снизили стоимость доставки за счет выбора автопоезда",
          text: "Отправили негабаритный груз автопоездом, чтобы сэкономить на ж/д платформах.",
        },
      ],
      cargoTitle: "Груз до отправки",
      cargoSolutionBigMobile: cargoSolutionBigMobile,
      cargoSolutionSmallLeftMobile: cargoSolutionSmallLeftMobile,
      cargoSolutionSmallRightMobile: cargoSolutionSmallRightMobile,
      cargoSolutionBigTablet: cargoSolutionBigTablet,
      cargoSolutionSmallLeftTablet: cargoSolutionSmallLeftTablet,
      cargoSolutionSmallRightTablet: cargoSolutionSmallRightTablet,
      cargoSolutionBigDesktop: cargoSolutionBigDesktop,
      cargoSolutionSmallLeftDesktop: cargoSolutionSmallLeftDesktop,
      cargoSolutionSmallRightDesktop: cargoSolutionSmallRightDesktop,
    },
    result: {
      title: "Результат",

      results: [
        {
          id: 0,
          number: "1.",
          text: "Всего за 45 суток доставили масштабный груз из Китая.",
        },
        {
          id: 1,
          number: "2.",
          text: "Сохранили целостность груза. Товар пришел без каких-либо повреждений, несмотря на перегрузы и сложности транспортировки негабаритных деталей.",
        },
        {
          id: 2,
          number: "3.",
          text: "Выполнили особые условия по доставке в одно время и на один терминал.",
        },
        {
          id: 3,
          number: "4.",
          text: "Сэкономили бюджет за счет оптимизации стоимости на всех этапах перевозки.",
        },
        {
          id: 4,
          number: "5.",
          text: "Клиент был спокоен благодаря сотрудникам ООО «ТрансАтлантик», которые контролировали каждый этап перевозки, обеспечивали бесперебойность и сохранность поставки. Каждый день мы информировали клиента о месте нахождения груза и давали прогнозы по дальнейшему следованию.",
        },
      ],
      alt: "image",
      cargoResultFirstMobile: cargoResultFirstMobile,
      cargoResultSecondMobile: cargoResultSecondMobile,
      cargoResultThirdMobile: cargoResultThirdMobile,
      cargoResultFirstTablet: cargoResultFirstTablet,
      cargoResultSecondTablet: cargoResultSecondTablet,
      cargoResultThirdTablet: cargoResultThirdTablet,
      cargoResultFirstDesktop: cargoResultFirstDesktop,
      cargoResultSecondDesktop: cargoResultSecondDesktop,
      cargoResultThirdDesktop: cargoResultThirdDesktop,
    },
  },
  {
    id: 1,
    path: "2",
    imgBlueMobile: craneBlueMobile,
    imgGrayMobile: craneGrayMobile,
    imgBlueTablet: craneBlueTablet,
    imgGrayTablet: craneGrayTablet,
    imgGrayDesktop: craneGrayDesktop,
    imgBlueDesktop: craneBlueDesktop,
    bigBlueImg: craneBlueDesktop,
    heading: "Гусеничные экскаваторы из Индии",
    caseHeading: "Гусеничные экскаваторы из Индии",
    alt: "crane",
    case: "india",
    options: {
      title: "Параметры доставки",
      conditions: [
        {
          id: 0,
          heading: "Что",
          text: "Гусеничные экскаваторы",
        },
        {
          id: 1,
          heading: "Сколько",
          text: "24 экскаватора",
        },
        { id: 2, heading: "Откуда ", text: "Индия" },
        { id: 3, heading: "Куда", text: "Регионы России" },
      ],
    },
    solution: {
      title: "Процесс",
      descr: [
        {
          id: 0,
          text: "Разработали специальные технические условия. Перевезли груз по морю на flat rack платформах длиной 40фт. по одному экскаватору на каждой. Провели таможенную очистку в порту Владивостока. До пунктов назначения перевозили по железной дороге, разместив по 2 экскаватора на одной платформе.",
        },
      ],
    },
    tasks: {
      title: "Задача",
      descr:
        "Доставить экскаваторы из Индии в разные регионы России в кратчайшие сроки.",
    },
    result: {
      title: "Результат",
      subDescr: "Доставили 24 экскаватора в 6 регионов России за 42 дня.",
      alt: "image",
      indiaResultFirstMobile: indiaResultFirstMobile,
      indiaResultSecondMobile: indiaResultSecondMobile,
      indiaResultFirstTablet: indiaResultFirstTablet,
      indiaResultSecondTablet: indiaResultSecondTablet,
      indiaResultFirstDesktop: indiaResultFirstDesktop,
      indiaResultSecondDesktop: indiaResultSecondDesktop,
    },
  },
  {
    id: 2,
    path: "3",
    imgBlueMobile: containerBlueMobile,
    imgGrayMobile: containerGrayMobile,
    imgBlueTablet: containerBlueTablet,
    imgGrayTablet: containerGrayTablet,
    imgGrayDesktop: containerGrayDesktop,
    imgBlueDesktop: containerBlueDesktop,
    bigBlueImg: containerBlueDesktop,
    heading: "1 000 контейнеров стали из Китая",
    caseHeading: "1 000 контейнеров стали из Китая",
    alt: "container",
    case: "china-third",
    options: {
      title: "Параметры доставки",
      conditions: [
        {
          id: 0,
          heading: "Что",
          text: "Рулонная сталь",
        },
        {
          id: 1,
          heading: "Сколько",
          text: "Более 1 000 контейнеров",
        },
        { id: 2, heading: "Откуда ", text: "Китай" },
        {
          id: 3,
          heading: "Куда",
          text: "Регионы России",
        },
      ],
    },
    solution: {
      title: "Процесс",
      descr: [
        {
          id: 0,
          text: "С момента поступления заявки максимально быстро забираем груз с завода и перевозим его в порты отправления. Без задержек по времени отправляем контейнеры морем во Владивосток. Сотрудники ООО «ТрансАтлантик» полностью под ключ управляют процессом перевозки и самостоятельно, без участия Клиента, поддерживают связь с продавцом груза в Китае.",
        },
      ],
    },
    tasks: {
      title: "Задача",
      descr: "Регулярная ритмичная поставка рулонной стали из Китая.",
    },
    result: {
      title: "Результат",
      subDescr:
        "Налажен процесс регулярных и надежных поставок. Оптимизация схемы доставки и слаженная работа команды позволили сократить бюджет и сроки перевозки. За 6 лет сотрудничества мы перевезли около 27 000 тонн рулонной стали, это более 1 000 контейнеров.",
      alt: "image",
      chinaSecondFirstMobile: chinaSecondFirstMobile,
      chinaSecondSecondMobile: chinaSecondSecondMobile,
      chinaSecondThirdMobile: chinaSecondThirdMobile,
      chinaSecondFirstTablet: chinaSecondFirstTablet,
      chinaSecondSecondTablet: chinaSecondSecondTablet,
      chinaSecondThirdTablet: chinaSecondThirdTablet,
      chinaSecondFirstDesktop: chinaSecondFirstDesktop,
      chinaSecondSecondDesktop: chinaSecondSecondDesktop,
      chinaSecondThirdDesktop: chinaSecondThirdDesktop,
    },
  },
  {
    id: 3,
    path: "4",
    imgBlueMobile: shipBlueMobile,
    imgGrayMobile: shipGrayMobile,
    imgBlueTablet: shipBlueTablet,
    imgGrayTablet: shipGrayTablet,
    imgGrayDesktop: shipGrayDesktop,
    imgBlueDesktop: shipBlueDesktop,
    bigBlueImg: shipBlueDesktop,
    heading: "20 000 тонн опасного груза из Китая",
    caseHeading: "20 000 тонн опасного груза из Китая",
    alt: "ship",
    case: "china-third",
    options: {
      title: "Параметры доставки",
      conditions: [
        {
          id: 0,
          heading: "Что",
          text: "Опасный груз в бочках/IBC контейнерах",
        },
        {
          id: 1,
          heading: "Сколько",
          text: "Постоянные поставки",
        },
        { id: 2, heading: "Откуда ", text: "Китай" },
        {
          id: 3,
          heading: "Куда",
          text: "Регионы России",
        },
      ],
    },
    solution: {
      title: "Процесс",
      descr: [
        {
          id: 0,
          text: "Самая важная и ответственная часть перевозки — верно подготовить перевозочные документы. Также с особой внимательностью мы следим за целостностью упаковки и правильностью размещения груза в контейнере на всех этапах перевозки — бочки с опасным грузом обматываются в пленку и вся партия обязательно обшивается досками.",
        },
      ],
    },
    tasks: {
      title: "Задача",
      descr:
        "Регулярная стабильная доставка опасного груза (6-ой класс опасности) из Китая.",
    },
    result: {
      title: "Результат",
      subDescr:
        "В течение 6 лет мы перевезли более 20 000 тонн опасного груза, радуя клиента надежными, бесперебойными и сохранными поставками.",
      alt: "image",
      chinaThirdFirstMobile: chinaThirdFirstMobile,
      chinaThirdSecondMobile: chinaThirdSecondMobile,
      chinaThirdThirdMobile: chinaThirdThirdMobile,
      chinaThirdFirstTablet: chinaThirdFirstTablet,
      chinaThirdSecondTablet: chinaThirdSecondTablet,
      chinaThirdThirdTablet: chinaThirdThirdTablet,
      chinaThirdFirstDesktop: chinaThirdFirstDesktop,
      chinaThirdSecondDesktop: chinaThirdSecondDesktop,
      chinaThirdThirdDesktop: chinaThirdThirdDesktop,
    },
  },
];

export const servicesPage = [
  {
    id: 0,
    path: "1",
    imgBluePreviewMobile: imgSeaBluePreviewMobile,
    imgBluePreviewTablet: imgSeaBluePreviewTablet,
    imgBluePreviewDesktop: imgSeaBluePreviewDesktop,
    imgBlue: seaServiceBlue,
    imgGray: seaServiceGray,
    imgBlueMobile: seaServiceBlueMobile,
    imgGrayMobile: seaServiceGrayMobile,
    imgBlueTablet: seaServiceBlueTablet,
    imgGrayTablet: seaServiceGrayTablet,
    imgBlueDesktop: seaServiceBlueDesktop,
    imgGrayDesktop: seaServiceGrayDesktop,
    heading: "Морские перевозки",
    alt: "sea",
    process: {
      title: "О перевозке",
      descr: "Отправим грузы любой сложности.",
      services: [
        {
          id: 0,
          heading: "Виды контейнеров",
          list: [
            {
              id: 0,
              text: "Универсальные крупнотоннажные контейнеры 20 и 40 футов.",
            },
            {
              id: 1,
              text: "Рефрижераторные контейнеры для грузов, требующих особые температурные условия.",
            },
            {
              id: 2,
              text: "Специализированные контейнеры типа «OPEN TOP» (с открытым верхом) и «FLAT RACK» (полуоткрытая платформа с размерами контейнера) для перевозки нестандартных грузов.",
            },
            {
              id: 3,
              text: "Транспортировка негабаритных и накатных грузов: RO-RO сервис",
            },
          ],
        },
        {
          id: 1,
          heading: "Поможем во всем",
          list: [
            {
              id: 0,
              text: "Подадим контейнер под погрузку/выгрузку на склад в любой стране ЮВА.",
            },
            { id: 1, text: "Предоставим оборудование из собственного парка." },
            {
              id: 2,
              text: "Предложим несколько вариантов доставки груза, поможем выбрать оптимальный.",
            },
            {
              id: 3,
              text: "Обеспечим особое отношение и заботу на всем пути перевозки.",
            },
          ],
        },
      ],
    },
    containers: {
      title: "Мультимодальный оператор",
      containers: {
        heading: "Перевозим всеми видами транспорта",
        list: [
          {
            id: 0,
            text: "Перевозки контейнеров и негабаритных грузов на любое расстояние.",
          },
          {
            id: 1,
            text: "Морские перевозки.",
          },
          {
            id: 2,
            text: "Железнодорожные перевозки.",
          },
          {
            id: 3,
            text: "Автомобильные перевозки.",
          },
          {
            id: 4,
            text: "Авиаперевозки.",
          },
        ],
      },
    },
  },

  {
    id: 1,
    path: "2",
    imgBlue: trainServiceBlue,
    imgGray: trainServiceGray,
    imgBluePreviewMobile: imgTrainBluePreviewMobile,
    imgBluePreviewTablet: imgTrainBluePreviewTablet,
    imgBluePreviewDesktop: imgTrainBluePreviewDesktop,
    imgBlueMobile: trainServiceBlueMobile,
    imgGrayMobile: trainServiceGrayMobile,
    imgBlueTablet: trainServiceBlueTablet,
    imgGrayTablet: trainServiceGrayTablet,
    imgBlueDesktop: trainServiceBlueDesktop,
    imgGrayDesktop: trainServiceGrayDesktop,
    heading: "Ж/Д перевозки",
    alt: "train",
    process: {
      title: "О перевозке",
      descr: "",
      services: [
        {
          id: 0,
          heading: "Налаженный процесс перевозок",
          list: [
            {
              id: 0,
              text: "Регулярные контейнерные поезда.",
            },
            {
              id: 1,
              text: "Повагонная отправка в международном сообщении и внутри страны.",
            },
          ],
        },
        {
          id: 1,
          heading: "Поможем во всем",
          list: [
            {
              id: 0,
              text: "Подадим контейнер под погрузку/выгрузку на склад в любой стране ЮВА.",
            },
            { id: 1, text: "Предоставим оборудование из собственного парка." },
            {
              id: 2,
              text: "Предложим несколько вариантов доставки груза, поможем выбрать оптимальный.",
            },
            {
              id: 3,
              text: "Обеспечим особое отношение и заботу на всем пути перевозки.",
            },
          ],
        },
      ],
    },
    transportation: {
      title: "Маршруты перевозок",
      descr: "",
      services: [
        {
          id: 0,
          heading: "Из портов Дальнего Востока в любую точку России",
          descr:
            "Налаженные связи с ж/д агентами и собственниками подвижных составов позволяют организовать отправку ваших грузов со станций Находка, Угольная, Мыс Чуркин и ряда других в ускоренных поездах до ключевых ж/д узлов РФ:",
          list: [
            {
              id: 0,
              text: "Москва",
            },
            {
              id: 1,
              text: "Санкт-Петербург",
            },
            {
              id: 2,
              text: "Екатеринбург",
            },
            {
              id: 3,
              text: "Новосибирск",
            },
            {
              id: 4,
              text: "Красноярск",
            },
            {
              id: 5,
              text: "Ростов-на-Дону",
            },
            {
              id: 7,
              text: "Тольятти",
            },
          ],
        },
        {
          id: 1,
          heading: "Китай: импорт и экспорт",
          descr:
            "Разветвлённая сеть железнодорожных агентов и агентов по консолидации грузов позволяет нам осуществлять отправку как целых, так и сборных контейнеров через основные станции в Китае на большинство контейнерных станций России.",
          list: [
            {
              id: 0,
              text: "Xian (Сиань)",
            },
            {
              id: 1,
              text: "Suzhou (Сучжоу)",
            },
            {
              id: 2,
              text: "Yiwu (Иу)",
            },
            {
              id: 3,
              text: "Changsha (Чанша)",
            },
            {
              id: 4,
              text: "Chongqing (Чунцин)",
            },
            {
              id: 5,
              text: "Guangzhou (Гуанчжоу)",
            },
          ],
        },
      ],
    },
    containers: {
      title: "Мультимодальный оператор",
      containers: {
        heading: "Перевозим всеми видами транспорта",
        list: [
          {
            id: 0,
            text: "Перевозки контейнеров и негабаритных грузов на любое расстояние.",
          },
          {
            id: 1,
            text: "Морские перевозки.",
          },
          {
            id: 2,
            text: "Железнодорожные перевозки.",
          },
          {
            id: 3,
            text: "Автомобильные перевозки.",
          },
          {
            id: 4,
            text: "Авиаперевозки.",
          },
        ],
      },
    },
  },

  {
    id: 2,
    path: "3",
    imgBlue: carServiceBlue,
    imgGray: carServiceGray,
    imgBluePreviewMobile: imgCarBluePreviewMobile,
    imgBluePreviewTablet: imgCarBluePreviewTablet,
    imgBluePreviewDesktop: imgCarBluePreviewDesktop,
    imgBlueMobile: carServiceBlueMobile,
    imgGrayMobile: carServiceGrayMobile,
    imgBlueTablet: carServiceBlueTablet,
    imgGrayTablet: carServiceGrayTablet,
    imgBlueDesktop: carServiceBlueDesktop,
    imgGrayDesktop: carServiceGrayDesktop,
    heading: "Автомобильные перевозки",
    alt: "auto",
    process: {
      title: "О перевозке",
      descr: "",
      services: [
        {
          id: 0,
          heading: "В рамках мультимодальной перевозки",
          list: [
            {
              id: 0,
              text: "Сервис для доставки грузов в рамках «первой и последней мили».",
            },
            {
              id: 1,
              text: "Перевозка контейнеров по РФ.",
            },
          ],
        },
        {
          id: 1,
          heading: "Поможем во всем",
          list: [
            {
              id: 0,
              text: "Подадим контейнер под погрузку/выгрузку на склад в любой стране ЮВА.",
            },
            { id: 1, text: "Предоставим оборудование из собственного парка." },
            {
              id: 2,
              text: "Предложим несколько вариантов доставки груза, поможем выбрать оптимальный.",
            },
            {
              id: 3,
              text: "Обеспечим особое отношение и заботу на всем пути перевозки.",
            },
          ],
        },
      ],
    },
    containers: {
      title: "Мультимодальный оператор",
      containers: {
        heading: "Перевозим всеми видами транспорта",
        list: [
          {
            id: 0,
            text: "Перевозки контейнеров и негабаритных грузов на любое расстояние.",
          },
          {
            id: 1,
            text: "Морские перевозки.",
          },
          {
            id: 2,
            text: "Железнодорожные перевозки.",
          },
          {
            id: 3,
            text: "Автомобильные перевозки.",
          },
          {
            id: 4,
            text: "Авиаперевозки.",
          },
        ],
      },
    },
  },
  {
    id: 3,
    path: "5",
    imgBlue: multiServiceBlue,
    imgBluePreviewMobile: multiServiceBluePreviewMobile,
    imgBluePreviewTablet: multiServiceBluePreviewTablet,
    imgGray: multiServiceGray,
    imgBlueMobile: multiServiceBlueMobile,
    imgGrayMobile: multiServiceGrayMobile,
    imgBlueTablet: multiServiceBlueTablet,
    imgGrayTablet: multiServiceGrayTablet,
    imgBlueDesktop: multiServiceBlueDesktop,
    imgGrayDesktop: multiServiceGrayDesktop,
    heading: "Мультимодальные перевозки",
    alt: "multi",
    about: {
      heading: "О перевозке",
      descr:
        "Мультимодальная перевозка — это транспортировка грузов по одному договору, выполненная различными видами транспорта.",
      subDescr:
        "ООО «ТрансАтлантик» осуществляет мультимодальные внутрироссийские и международные контейнерные перевозки морским, железнодорожным и автомобильным транспортом через основные порты Дальнего Востока, Новороссийска, Санкт-Петербурга, а также через сухопутные погранпереходы.",
    },
    routes: {
      heading: "Маршруты перевозок",
      routes: [
        {
          id: 0,
          title: "Через порты Дальнего востока",
          descrFirst:
            "Доставим ваш груз из стран Азиатско-Тихоокеанского региона в контейнере или балком на любой из основных терминалов порта Восточный/Находка (ВСК, ППК-1, НМРП) и порта Владивосток (ВМТП, ВМКТ, ВМПП, Соллерс).",
          descrSecond:
            "Проконтролируем весь процесс: отследим подход судна в порт, проведем внутрипортовое экспедирование, проследим за выполнением всех таможенных предписаний, оформим внутритаможенный транзит.",
          descrThird:
            "Максимально быстро отправим железной дорогой в составе ускоренных контейнерных поездов или повагонной отправкой, примем на станции назначения и доставим на ваш склад.",
        },
        {
          id: 1,
          title:
            "Через порты Санкт Петербурга, порт Балтийск (Калининград), Мурманск",
          descrFirst:
            "Привезем ваш груз из стран Азиатско-Тихоокеанского региона в контейнерах или балком на основные терминалы Санкт-Петербурга (ПКТ, Бронка, КТСП), в Калининград (п. Балтийск), а также в Мурманск. Наши представители примут контейнеры в порту, организуют таможенное оформление и перевалку на ЖД или авто. Если необходимо — организуем перетарку в фуру, погрузку негабаритного груза на трал, его крепление и отправим груз до пункта назначения по оптимальному маршруту.",
          descrSecond: null,
          descrThird: null,
        },
        {
          id: 2,
          title: "Через порт Новороссийск",
          descrFirst:
            "Отправим ваш груз из стран Азиатско-Тихоокеанского региона, а также Турции, ОАЭ, Египта, других Африканских республик в контейнерах на основные терминалы Новороссийска (НУТЭП, НЛЭ). Наши представители примут контейнеры, организуют таможенное оформление и перевалку на ЖД или авто. При необходимости организуем перетарку в порту или на нашем складе в фуры и отправим груз до пункта назначения по оптимальному маршруту. Поможем в прохождении карантинного/фитосанитарного контроля и оформлении внутритаможенного транзита.",
          descrSecond: null,
          descrThird: null,
        },
        {
          id: 3,
          title: "Через Китай, Гонг-Конг, Иран, Турцию ",
          descrFirst:
            "Наше новое направление. Индивидуальные схемы перевозки грузов, с перетаркой и без — для решения ваших уникальных задач. Это возможно благодаря нашей наработанной сети агентов в транзитных портах.",
          descrSecond: null,
          descrThird: null,
        },
      ],
    },
  },
  {
    id: 4,
    path: "4",
    imgBlue: aviaServiceBlue,
    imgGray: aviaServiceGray,
    imgBlueMobile: aviaServiceBlueMobile,
    imgGrayMobile: aviaServiceGrayMobile,
    imgBlueTablet: aviaServiceBlueTablet,
    imgGrayTablet: aviaServiceGrayTablet,
    imgBlueDesktop: aviaServiceBlueDesktop,
    imgGrayDesktop: aviaServiceGrayDesktop,
    heading: "Авиаперевозки",
    alt: "avia",
    process: {
      title: "О перевозке",
      descr: "",
      services: [
        {
          id: 0,
          heading: "От двери до двери",
          list: [
            {
              id: 0,
              text: "Заберём груз у отправителя и доставим в аэропорт.",
            },
            {
              id: 1,
              text: "Из аэропорта России доставим напрямую получателю.",
            },
          ],
        },
        {
          id: 1,
          heading: "Поможем во всем",
          list: [
            {
              id: 0,
              text: "Подберём оптимальный рейс.",
            },
            {
              id: 1,
              text: "Обеспечим логистику при транзите до и после аэропорта.",
            },
            {
              id: 2,
              text: "Предложим несколько вариантов доставки груза.",
            },
            {
              id: 3,
              text: "Окажем особое отношение и заботу на всём пути перевозки.",
            },
          ],
        },
      ],
    },
    transportation: {
      title: "Маршруты перевозок",
      descr: "",
      services: [
        {
          id: 0,
          heading: "",
          list: [
            {
              id: 0,
              text: "Китай",
            },
            {
              id: 1,
              text: "Индия",
            },
            {
              id: 2,
              text: "Объединённые Арабские Эмираты",
            },
            {
              id: 3,
              text: "Южная Корея",
            },
          ],
        },
      ],
    },
    containers: {
      title: "Мультимодальный оператор",
      containers: {
        heading: "Перевозим всеми видами транспорта",
        list: [
          {
            id: 0,
            text: "Перевозки контейнеров и негабаритных грузов на любое расстояние.",
          },
          {
            id: 1,
            text: "Морские перевозки.",
          },
          {
            id: 2,
            text: "Железнодорожные перевозки.",
          },
          {
            id: 3,
            text: "Автомобильные перевозки.",
          },
          {
            id: 4,
            text: "Авиаперевозки.",
          },
        ],
      },
    },
  },
];

export const parkPage = [
  {
    id: 0,
    img: containerSmall,
    heading: "Стандартный 20-футовый контейнер: 20 Dry Freight Container",
    descr:
      "Самый универсальный вид контейнера. Подойдет для большинства грузов",
    weight: "22 000",
    volume: "33",
    length: "5898",
    width: "2352",
    height: "2393",
    property: "Жесткие",
  },
  {
    id: 1,
    img: containerBig,
    heading: "Высокий 40-футовый контейнер: 40 Dry High Cube Container",
    descr:
      "Удлиненная вдвое версия самого популярного контейнера для перевозок ",
    weight: "27 000",
    volume: "67",
    length: "12 032",
    width: "2352",
    height: "2393",
    property: "Жесткие",
  },
];

export const cargo = [
  { id: 0, text: "Грузы на паллетах" },
  { id: 1, text: "Любые упакованные  «мелкие товары»" },
  { id: 2, text: "Электрооборудование" },
  { id: 3, text: "Опасные грузы (при наличии документов)" },
  { id: 4, text: "Металлопрокат" },
  { id: 5, text: "Пиломатериалы" },
  { id: 6, text: "Жидкие грузы во флекситанках" },
  { id: 7, text: "И почти все, что угодно" },
];

export const firstRules = [
  {
    id: 0,
    number: "1.1",
    text: "Настоящий документ определяет политику ООО «ТрансАтлантик» (далее — Администрация сайта) в отношении обработки персональных данных и действует в отношении всей информации, которую Администрация сайта может получить о Пользователе во время использования сайта, именуемого далее Сайт, сервисов, продуктов или услуг, предоставляемых Администрацией сайта в ходе любых соглашений или договоров с Пользователем. Регистрация на Сайте означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней условиями обработки персональной информации. В случае несогласия с этими условиями Пользователь должен воздержаться от использования Сервисов.",
  },
  {
    id: 1,
    number: "1.2",
    text: "Настоящая Политика разработана в соответствии с действующим законодательством Российской Федерации о персональных данных.  ",
  },
  {
    id: 2,
    number: "1.3",
    text: "Действие настоящей Политики распространяется на все процессы по обработке, а именно по сбору, записи, систематизации, накоплению, хранению, уточнению, извлечению, использованию, передачи (распространению, предоставлению, доступу), обезличиванию, блокированию, удалению, уничтожению персональных данных, осуществляемых с использованием средств автоматизации и без использования таких средств.",
  },
];

export const secondRules = [
  {
    id: 0,
    number: "2.1",
    text: "В рамках настоящей Политики под «персональными данными» Пользователя понимаются:",
    subRules: [
      {
        id: 0,
        number: "2.1.1",
        text: "Данные, которые Пользователь предоставляет о себе самостоятельно при создании заявки, отклика на вакансию, подписке на рассылку или в процессе использования сайта, включая персональные данные Пользователя.",
      },
      {
        id: 1,
        number: "2.1.2",
        text: "Иная информация о Пользователе, обработка которой предусмотрена условиями оказания услуг, предоставляемых Администрацией сайта.",
      },
    ],
    link: null,
  },
  {
    id: 1,
    number: "2.2",
    text: "Администрация сайта исходит из того, что Пользователь предоставляет достоверные и достаточные персональные данные и поддерживает эти данные в актуальном состоянии.",
    link: null,
    subRules: null,
  },
  {
    id: 2,
    number: "2.3",
    text: "Администрация сайта имеет право вносить изменения в настоящую Политику обработки персональных данных. Новая редакция Политики вступает в силу с момента ее размещения. Действующая редакция постоянно доступна на странице по адресу: ",
    link: "https://transatlantic.pro/privacy",
    subRules: null,
  },
];

export const thirdRules = [
  {
    id: 0,
    number: "3.1",
    text: "Администрация сайта собирает и хранит только те персональные данные, которые необходимы для предоставления услуг Пользователю.",
    subRules: null,
  },
  {
    id: 1,
    number: "3.2",
    text: "Администрация сайта обрабатывает персональные данные Пользователей в следующих целях:",
    subRules: [
      {
        id: 0,
        number: "3.2.1",
        text: "Идентификация стороны.",
      },
      {
        id: 1,
        number: "3.2.2",
        text: "Предоставление Пользователю персонализированных предложений и исполнение соглашений и договоров.",
      },
      {
        id: 2,
        number: "3.2.3",
        text: "Связь с Пользователем, в том числе направление уведомлений, запросов и информации, а также обработка запросов от Пользователя.",
      },
      {
        id: 3,
        number: "3.2.4",
        text: "Улучшение качества сайта, сервисов и услуг, предоставляемых Администрацией сайта, разработка новых сервисов.",
      },
      {
        id: 4,
        number: "3.2.5",
        text: "Проведение статистических и иных исследований на основе обезличенных данных.",
      },
    ],
  },
];

export const fourthRules = [
  {
    id: 0,
    number: "4.1",
    text: "Обработка персональных данных осуществляется на законной и справедливой основе;",
  },
  {
    id: 1,
    number: "4.2",
    text: "Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных;",
  },
  {
    id: 2,
    number: "4.3",
    text: "Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместных между собой;",
  },
  {
    id: 3,
    number: "4.4",
    text: "Обработке подлежат только те персональные данные, которые отвечают целям их обработки;",
  },
  {
    id: 4,
    number: "4.5",
    text: "Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Обрабатываемые персональные данные не являются избыточными по отношению к заявленным целям обработки;",
  },
  {
    id: 5,
    number: "4.6",
    text: "При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к заявленным целям их обработки.",
  },
  {
    id: 6,
    number: "4.7",
    text: "Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные подлежат уничтожению, либо обезличиванию по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.",
  },
];

export const fifthRules = [
  {
    id: 0,
    number: "5.1",
    text: "Обработка персональных данных осуществляется с соблюдением принципов и правил, установленных Федеральным законом «О персональных данных». Обработка персональных данных допускается в следующих случаях:",
    subRules: [
      {
        id: 0,
        number: "5.1.1",
        text: "обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных;",
      },
      {
        id: 1,
        number: "5.1.2",
        text: "обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для: осуществления и выполнения возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей;",
      },
      {
        id: 2,
        number: "5.1.3",
        text: "обработка персональных данных необходима для: осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве;",
      },
      {
        id: 3,
        number: "5.1.4",
        text: "обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем;",
      },
      {
        id: 4,
        number: "5.1.5",
        text: "обработка персональных данных необходима для защиты жизни, здоровья или иных жизненно важных интересов субъекта персональных данных, если получение согласия субъекта персональных данных невозможно;",
      },
      {
        id: 5,
        number: "5.1.6",
        text: "обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц, либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных;",
      },
      {
        id: 6,
        number: "5.1.7",
        text: "обработка персональных данных осуществляется в статистических или иных исследовательских целях, при условии обязательного обезличивания персональных данных. Исключение составляет обработка персональных данных в целях продвижения товаров, работ, услуг на рынке путем осуществления прямых контактов с потенциальным потребителем с помощью средств связи;",
      },
      {
        id: 7,
        number: "5.1.8",
        text: "осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных, либо по его просьбе (далее — персональные данные, сделанные общедоступными субъектом персональных данных);",
      },
      {
        id: 8,
        number: "5.1.9",
        text: "осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом.",
      },
    ],
  },
  {
    id: 1,
    number: "5.2",
    text: "Биометрические персональные данные (сведения, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность и которые используются оператором для установления личности субъекта персональных данных) Администрацией сайта не обрабатываются.",
    subRules: null,
  },
  {
    id: 2,
    number: "5.3",
    text: "Администрация сайта не осуществляет трансграничную передачу персональных данных.",
    subRules: null,
  },
  {
    id: 3,
    number: "5.4",
    text: "Принятие на основании исключительно автоматизированной обработки персональных данных решений, порождающих юридические последствия в отношении субъекта персональных данных или иным образом затрагивающих его права и законные интересы, не осуществляется.",
    subRules: null,
  },
  {
    id: 4,
    number: "5.5",
    text: "При отсутствии необходимости письменного согласия субъекта на обработку его персональных данных факт добровольного предоставления таких данных субъектом или его представителем признается сторонами как факт предоставления персональных данных с согласия субъекта.",
    subRules: null,
  },
  {
    id: 5,
    number: "5.6",
    text: "Администрация сайта вправе поручить обработку персональных данных другому лицу, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора (далее — поручение оператора). При этом Администрация сайта в договоре обязует лицо, осуществляющее обработку персональных данных по поручению Администрации сайта, соблюдать принципы и правила обработки персональных данных, предусмотренные федеральным законом.",
    subRules: null,
  },
  {
    id: 6,
    number: "5.7",
    text: "В случае если Администрация сайта поручает обработку персональных данных другому лицу, ответственность перед субъектом персональных данных за действия указанного лица несет Администрация сайта. Лицо, осуществляющее обработку персональных данных по поручению Администрации сайта, несет ответственность перед Администрацией сайта.",
    subRules: null,
  },
  {
    id: 7,
    number: "5.8",
    text: "Администрация сайта обязуется и обязует иные лица, получившие доступ к персональным данным, не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта.",
    subRules: null,
  },
];

export const sixthRules = [
  {
    id: 0,
    number: "6.1",
    text: "В соответствии с требованиями Федерального закона № 152-ФЗ «О персональных данных» Администрация сайта обязана:",
    subRules: [
      {
        id: 0,
        number: "6.1.1",
        text: "Предоставлять субъекту персональных данных по его запросу информацию, касающуюся обработки его персональных данных, либо на законных основаниях предоставить отказ.",
        subParagraphs: null,
      },
      {
        id: 1,
        number: "6.1.2",
        text: "По требованию субъекта персональных данных уточнять обрабатываемые персональные данные, блокировать или удалять, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки.",
        subParagraphs: null,
      },
      {
        id: 2,
        number: "6.1.3",
        text: "Уведомлять субъекта персональных данных об обработке персональных данных в том случае, если персональные данные были получены не от субъекта персональных данных, за исключением следующих случаев:",
        subParagraphs: [
          {
            id: 0,
            number: "6.1.3.1",
            text: "Субъект уведомлен об осуществлении обработки его персональных данных соответствующим оператором;",
          },
          {
            id: 1,
            number: "6.1.3.2",
            text: "Персональные данные получены Администрацией сайта на основании федерального закона или в связи с исполнением договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных;",
          },
          {
            id: 2,
            number: "6.1.3.3",
            text: "Персональные данные сделаны общедоступными субъектом персональных данных или получены из общедоступного источника;",
          },
          {
            id: 3,
            number: "6.1.3.4",
            text: "Администрация сайта осуществляет обработку персональных данных для статистических или иных исследовательских целей, если при этом не нарушаются права и законные интересы субъекта персональных данных;",
          },
          {
            id: 4,
            number: "6.1.3.5",
            text: "Предоставление субъекту персональных данных сведений, содержащихся в Уведомлении об обработке персональных данных, нарушает права и законные интересы третьих лиц.",
          },
        ],
      },
      {
        id: 3,
        number: "6.1.4",
        text: "В случае достижения цели обработки персональных данных незамедлительно прекратить обработку персональных данных и уничтожить соответствующие персональные данные в срок, не превышающий тридцати дней с даты достижения цели обработки персональных данных, если иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных, иным соглашением между Администрацией сайта и субъектом персональных данных либо если Администрация сайта не вправе осуществлять обработку персональных данных без согласия субъекта персональных данных на основаниях, предусмотренных № 152-ФЗ «О персональных данных» или другими федеральными законами.",
        subParagraphs: null,
      },
      {
        id: 4,
        number: "6.1.5",
        text: "В случае отзыва субъектом персональных данных согласия на обработку своих персональных данных, прекратить обработку персональных данных и уничтожить персональные данные в срок, не превышающий тридцати дней с даты поступления указанного отзыва, если иное не предусмотрено соглашением между Администрацией сайта и субъектом персональных данных. Об уничтожении персональных данных Администрация сайта обязана уведомить субъекта персональных данных.",
        subParagraphs: null,
      },
      {
        id: 5,
        number: "6.1.6",
        text: "В случае поступления требования субъекта о прекращении обработки персональных данных в целях продвижения товаров, работ, услуг на рынке немедленно прекратить обработку персональных данных.",
        subParagraphs: null,
      },
    ],
  },
];

export const seventhRules = [
  {
    id: 0,
    number: "7.1",
    text: "При обработке персональных данных Администрация сайта принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных.",
    subRules: null,
  },
  {
    id: 1,
    number: "7.2",
    text: "Обеспечение безопасности персональных данных достигается, в частности:",
    subRules: [
      {
        id: 0,
        number: "7.2.1",
        text: "определением угроз безопасности персональных данных при их обработке в информационных системах персональных данных;",
      },
      {
        id: 1,
        number: "7.2.2",
        text: "применением организационных и технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах персональных данных, необходимых для выполнения требований к защите персональных данных, исполнение которых обеспечивает установленные Правительством Российской Федерации уровни защищенности персональных данных;",
      },
      {
        id: 2,
        number: "7.2.3",
        text: "применением прошедших в установленном порядке процедуру оценки соответствия средств защиты информации;",
      },
      {
        id: 3,
        number: "7.2.4",
        text: "оценкой эффективности принимаемых мер по обеспечению безопасности персональных данных до ввода в эксплуатацию информационной системы персональных данных;",
      },
      {
        id: 4,
        number: "7.2.5",
        text: "обнаружением фактов несанкционированного доступа к персональным данным и принятием мер;",
      },
      {
        id: 5,
        number: "7.2.6",
        text: "восстановлением персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к ним;",
      },
      {
        id: 6,
        number: "7.2.7",
        text: "контролем за принимаемыми мерами по обеспечению безопасности персональных данных и уровня защищенности информационных систем персональных данных.",
      },
    ],
  },
];
